export default "__VITE_ASSET__BnnR6LNT__"